module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Black-Beauty.aa3a08c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Black-Beauty.jpg
// module id = rycl
// module chunks = 0